import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetListsQuery } from '../services/bookmarksApi';
import styles from '../css/Bookmarks.module.css';

const Bookmarks = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const { data, isLoading } = useGetListsQuery(undefined, {
    skip: !isAuthenticated,
    refetchOnMountOrArgChange: true,
  });

  const lists = data?.data ?? [];
  const totalItems = lists.reduce((sum, list) => sum + (list.items_count ?? 0), 0);

  if (!isAuthenticated) {
    return (
      <div className={styles.bookmarksPage}>
        <Link to="/profile" className={styles.backButton}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Назад к профилю
        </Link>

        <div className={styles.guestState}>
          <div className={styles.guestTop}>
            <div className={styles.guestBadge}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
              </svg>
              Закладки
            </div>

            <h1 className={styles.guestTitle}>Сохраняйте дорамы, чтобы не потерять их</h1>
            <p className={styles.guestText}>
              Эта страница собирает ваши сохранённые тайтлы в одном месте. После входа здесь появятся личные списки, и вы сможете быстро возвращаться к интересным дорамам.
            </p>

            <div className={styles.guestActions}>
              <Link to="/auth/login" className={styles.loginButton}>
                Войти
              </Link>
              <Link to="/catalog" className={styles.secondaryButton}>
                Открыть каталог
              </Link>
            </div>
          </div>

          <div className={styles.guestShelf}>
            <div className={styles.guestShelfHeader}>
              <span className={styles.guestShelfTitle}>Что дадут закладки</span>
              <span className={styles.guestShelfHint}>После входа</span>
            </div>

            <div className={styles.guestListRow}>
              <div className={styles.guestListCard}>
                <span className={`${styles.guestListDot} ${styles.guestListDotWarm}`} />
                <div className={styles.guestListMeta}>
                  <span className={styles.guestListName}>Сохранять интересные дорамы</span>
                  <span className={styles.guestListInfo}>Чтобы не искать их заново позже</span>
                </div>
              </div>

              <div className={styles.guestListCard}>
                <span className={`${styles.guestListDot} ${styles.guestListDotSoft}`} />
                <div className={styles.guestListMeta}>
                  <span className={styles.guestListName}>Быстро возвращаться к сохранённому</span>
                  <span className={styles.guestListInfo}>Все нужные тайтлы будут в одном месте</span>
                </div>
              </div>

              <div className={styles.guestListCard}>
                <span className={`${styles.guestListDot} ${styles.guestListDotCool}`} />
                <div className={styles.guestListMeta}>
                  <span className={styles.guestListName}>Держать порядок в просмотре</span>
                  <span className={styles.guestListInfo}>И не терять то, что хочется посмотреть</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className={styles.bookmarksPage}>
        <div className={styles.loadingState}>Загрузка закладок...</div>
      </div>
    );
  }

  return (
    <div className={styles.bookmarksPage}>
      <Link to="/profile" className={styles.backButton}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
        Назад к профилю
      </Link>

      <div className={styles.header}>
        <h1 className={styles.title}>Закладки</h1>
        <p className={styles.subtitle}>
          Списков: <span className={styles.count}>{lists.length}</span> · Сохранено дорам: <span className={styles.count}>{totalItems}</span>
        </p>
      </div>

      {lists.length > 0 ? (
        <div className={styles.listsGrid}>
          {lists.map((list) => (
            <div key={list.id} className={styles.listCard}>
              <div className={styles.listCardTop}>
                <span
                  className={styles.listColor}
                  style={list.color_hex ? { backgroundColor: list.color_hex } : undefined}
                />
                <span className={styles.listCount}>{list.items_count ?? 0}</span>
              </div>
              <h2 className={styles.listTitle}>{list.name}</h2>
              <p className={styles.listMeta}>Сохранённых дорам: {list.items_count ?? 0}</p>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
            </svg>
          </div>
          <h2 className={styles.emptyTitle}>Закладки пока пусты</h2>
          <p className={styles.emptyDescription}>
            Добавляйте дорамы в списки из карточек или со страницы просмотра, и они появятся здесь.
          </p>
        </div>
      )}
    </div>
  );
};

export default Bookmarks;
